import { colors, durations, easings } from '../../constants';
import { mq, mqH, mqLandscape } from '../../utils/mediaQuery';

export const widgetContainer = {
  height: '530px',
  backgroundColor: colors.black,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  margin: 'auto',
  justifyContent: 'center',
  fontFamily: `ibm-plex-sans, "Helvetica Neue", Arial, sans-serif`,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  [`@media (min-width: 580px) and (max-width: 999px)`]: {
    height: 385,
  },
  [`@media (min-width: 1240px)`]: {
    height: 460,
  },
};

export const carouselSlideStyle = {
  position: 'relative',
  margin: 'auto',
  display: 'flex',
  zIndex: 1,
  willChange: 'opacity, transform',
  height: 300,
  [`${mqLandscape}`]: {
    height: 200,
  },
  [`${mq('sm')} and ${mqH('xs')}`]: {
    height: 200,
  },
};

export const carouselStyling = {
  height: ' 100%',
  width: '100%',
};

// export const carouselSlidePillarLabels = {
//   color: colors.white,
//   position: 'absolute',
//   left: 0,
//   right: 0,
//   margin: 'auto',
//   display: 'flex',
//   textAlign: 'left',
//   transform: 'translateY(calc(100% + 5px))',
//   justifyContent: 'space-between',
//   willChange: 'opacity',
//   bottom: 152,
//   [`${mqLandscape}`]: {
//     display: 'none',
//   },
//   [`${mq('sm')} and ${mqH('xs')}`]: {
//     display: 'flex',
//     bottom: 90,
//   },
//   [mq('sm')]: {
//     bottom: 122,
//   },
//   [mq('md')]: {
//     bottom: 160,
//   },
// };

// export const labelStyling = (origWidthOfPillar) => {
//   return {
//     fontSize: 10,
//     width: origWidthOfPillar,
//     whiteSpace: 'nowrap',
//     paddingLeft: 2,
//     left: origWidthOfPillar + 20,
//     color: colors.grey,
//     '&:first-of-type': {
//       left: 0,
//     },
//     [mq('sm')]: {
//       left: origWidthOfPillar + 30,
//     },
//   };
// };

export const sceneStyling = {
  height: 300,
  width: '100%',
  margin: 'auto auto 152px auto',
  [`${mqLandscape}`]: {
    margin: 'auto auto 80px auto',
    height: 200,
  },
  [`${mq('sm')} and ${mqH('xs')}`]: {
    margin: 'auto auto 55px auto',
    height: 230,
  },
  [mq('md')]: {
    margin: 'auto auto 70px auto',
  },
};

export const carouselNavigation = (direction) => {
  const style = {
    position: 'absolute',
    top: '50%',
    width: 40,
    height: 40,
    marginTop: -20,
    zIndex: 2,
    willChange: 'opacity',
    transition: `opacity ${durations.serviceTitleFadeDuration}ms ${easings.viewDetailsOpacity}`,
  };

  style[direction] = 15;

  style[`${mqLandscape}`] = {
    [direction]: 25,
  };

  style[`${mq('sm')} and ${mqH('xs')}`] = {
    [direction]: 15,
  };

  style[mq('md')] = {
    [direction]: 15,
  };

  return style;
};

export const resetButtonStyle = {
  color: colors.white,
  appearance: 'none',
  tapHighlightColor: 'transparent',
  border: 0,
  borderRadius: 0,
  outline: 'none',
  padding: 0,
  background: 'transparent',
  verticalAlign: 'bottom',
  cursor: 'pointer',
  userSelect: 'none',
  fontFamily: `ibm-plex-sans, "Helvetica Neue", Arial, sans-serif`,
  '&:active': {
    WebkitTapHighlightColor: 'transparent',
    outline: 'none',
    touchAction: 'manipulation',
  },
  '&:focus': {
    WebkitTapHighlightColor: 'transparent',
    outline: 'none',
    touchAction: 'manipulation',
  },
  '&:disabled': {
    backgroundColor: 'transparent',
    border: '0',
    color: colors.white,
    cursor: 'default',
  },
  '&:hover': {
    '&:disabled': {
      backgroundColor: 'transparent',
      border: '0',
      color: colors.white,
      cursor: 'default',
    },
  },
};
